import moment from "moment";
export class TimerModel {
    get isTimerRunning() {
        return this.started && !this.stopped;
    }
    ;
    get timerString() {
        if (!this.started)
            return "";
        let date = new Date(0);
        date.setTime(this.timeLeft * 1000);
        let hours = date.getHours() % 12;
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        let minuteString = minutes < 10 ? `0${minutes}` : minutes;
        let secondString = seconds < 10 ? `0${seconds}` : seconds;
        let result = hours > 0 ? `${hours}:${minuteString}:${secondString}` : `${minuteString}:${secondString}`;
        return result;
    }
    ;
    startTimer() {
        if (this.started)
            return;
        this.started = true;
        this.stopped = false;
        let tick = () => {
            if (this.stopped)
                return;
            if (this.onStarted)
                this.onStarted();
            let now = moment();
            let end = moment(this.endTime.toISOString());
            let timeLeft = moment.duration(end.diff(now)).asSeconds();
            this.timeLeft = timeLeft <= 0 ? 0 : timeLeft;
            if (timeLeft <= 0) {
                this.stopTimer();
                if (this.onFinished)
                    this.onFinished();
            }
            this.timeoutId = window.setTimeout(tick, 1000);
        };
        tick();
    }
    ;
    stopTimer() {
        if (this.stopped)
            return;
        this.stopped = true;
        this.started = false;
        clearTimeout(this.timeoutId);
    }
    ;
    constructor(endTime, onStartedCallback, onFinishedCallback) {
        this.timeoutId = 0;
        this.started = false;
        this.stopped = false;
        this.timeLeft = 0;
        this.endTime = new Date();
        this.endTime = endTime;
        this.onStarted = onStartedCallback;
        this.onFinished = onFinishedCallback;
    }
}
